export default __webpack_public_path__ + "static/media/print-alert.91907564.svg";